import { OTA_POS } from "./ota_pos.model";
import { OTA_VehRetResRQCore } from "./ota_vehretresrqcore.model";

export class OTA_VehRetResRQ {
    public pos = new OTA_POS();
    public vehRetResRQCore = new OTA_VehRetResRQCore();
}